import type { ServerLogger } from './ServerLogger';

let serverLogger: ServerLogger | null = null;

export const setupServerLogger = (logger: ServerLogger): void => {
  serverLogger = logger;
};

export const getServerLogger = () => serverLogger;
